import _ from 'lodash';

import * as constants from './MainModeFavorite.constants';
import * as services from './MainModeFavorite.service';

const state = {
  isRequest: false,
};

const mutations = {
  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getFavorite({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getFavorite(payload);
    let favorite = res.data.data;
    favorite = favorite ? favorite : {};
    favorite = {
      ...favorite,
      books: _.map(favorite.books, (book) => {
        return {
          ...book,
          videos: _.map(book.videos, (video) => ({
            ...video,
            courseId: favorite.courseId,
            bookId: book.bookId,
            bookName: book.bookName,
            bookIcon: book.bookIcon,
            isNew: video.newPath,
            endOfReading: false,
          })),
        };
      }),
    };
    let books = _.map(favorite.books, (book) => book.videos);
    let bookmark = _.flatten(books);
    commit('Mixins/Bookmark/GET_BOOKMARK_SUCCESS', bookmark, { root: true });
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
